export const configCommunities = {
    en: {
        country: 'US',
        topCountries: ['US', 'AU', 'CA', 'IN', 'NZ', 'ZA', 'GB'],
    },
    fr: {
        country: 'FR',
        topCountries: ['FR', 'BE', 'LU', 'CA'],
    },
    de: {
        country: 'DE',
        topCountries: ['DE', 'LU', 'AT'],
    },
    es: {
        country: 'ES',
        topCountries: ['ES', 'MX', 'CO', 'CA', 'US', 'AR', 'PE', 'CL'],
    },
    pt: {
        country: 'PT',
        topCountries: ['PT', 'BR'],
    },
};
